import { HMObject } from "../../types/Classes.js";
import { horairesExtremesForWeek } from "./horairesExtremesForWeek.js";
function intersectHorairesWithPlages(horaire, plages) {
    const horairesExtremes = horairesExtremesForWeek(horaire);
    if (!horairesExtremes) {
        throw new Error("horairesExtremes is undefined in intersectHorairesWithPlages, horaire provided is invalid");
    }
    const hmOhrairesExtremes = {
        start: new HMObject(horairesExtremes.start),
        end: new HMObject(horairesExtremes.end),
    };
    return plages.map((plage) => {
        let finalStart = new HMObject(plage.start);
        let finalEnd = new HMObject(plage.end);
        if (finalStart.isBefore(hmOhrairesExtremes.start)) {
            finalStart = hmOhrairesExtremes.start;
        }
        if (finalEnd.isAfter(hmOhrairesExtremes.end)) {
            finalEnd = hmOhrairesExtremes.end;
        }
        return { start: finalStart.getHMObjDTO(), end: finalEnd.getHMObjDTO() };
    });
}
function earliestStartPossible(horaire, duration) {
    return Object.entries(horaire.horaire).reduce((result, [day, plages]) => {
        return {
            ...result,
            [day]: plages.map((plage) => {
                const plageEnd = new HMObject(plage.end);
                return plageEnd.minusWithClone(duration).getHMObjDTO();
            }),
        };
    }, {});
}
function earliersStartPossibleToFrench(horaire, duration) {
    const result = earliestStartPossible(horaire, duration);
    return Object.entries(result).reduce((acc, [day, hms]) => {
        return (acc +
            " le " +
            day +
            " à " +
            hms.map((hm) => hm.heure + "h" + hm.minute).join(", "));
    }, "");
}
export { intersectHorairesWithPlages, earliersStartPossibleToFrench, earliestStartPossible, };
//# sourceMappingURL=interserctHorairesWithPlages.js.map